import { Component, OnInit } from '@angular/core';
import {IbRequest} from '../ib-request';
import {IbResponse} from '../ib-response';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { CallBackEndService } from '../call-back-end.service';
declare var getHexAscii: any;

import 'rxjs/Rx';
@Component({
  selector: 'app-update-email',
  templateUrl: './update-email.component.html',
  styleUrls: ['./update-email.component.css']
})
export class UpdateEmailComponent implements OnInit {
storedOtp : string ='';
  isShow : string='';
  error : string='';
  invalidOtp : string='';
  otp : string ='';
  currentEmail : string ='';
  newEmail : string ='';
  successResponse : string ;
  validemail : string ='';
  valideoldmail : string ='';
  validenewmail : string ='';
   isDisabled : boolean = false;
  valideoldmailBlank : string ='';
  emailLength : string ='';
  newemailLength : string ='';
  existingEmail=sessionStorage.getItem('emailId');
  otpBlank : string ='';
  isError1:boolean=false;
  otpError: string;
  regNumsOnly =/^\d+$/;

  constructor(private webService: CallBackEndService,private spinnerService: Ng4LoadingSpinnerService) { }

  submotEmail() {

    if (this.newEmail === undefined || this.newEmail === '') {
      this.validenewmail = "notemailBlank";
      this.isDisabled = true;
    } else {
      this.otpError='';
      this.otp='';
      this.isDisabled = true;
      this.spinnerService.show();
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      console.log("come inside");
      //this.isLoad = true;
      request.param1 = getHexAscii('',sessionStorage.getItem('storedUserName') + this.currentEmail + this.newEmail);
      request.param2 =sessionStorage.getItem('storedUserName');
      request.param3 = this.currentEmail;
      request.param4 = this.newEmail;
      this.webService.getResponse(request, 'generateOtp').subscribe((data: IbResponse) => {
        response = data;
        //this.isLoad = false;
        this.spinnerService.hide();
        if (response !== null && response.status === 'S200') {
          
          console.log("otp iss " + response.param1);
          this.isShow = 'page2';
          this.storedOtp = response.param1;
        } else if (response !== null) {
          this.error = response.param1;
          this.invalidOtp="";
        } else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
  submitOTP()
  {
    // if(this.otp === '' || this.otp === undefined)
    // {
    //   this.otpBlank='no';
    // }
   
    // else{
      if(this.validateOtp()){
      const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
     var otpDetails={
        'userName' :sessionStorage.getItem('storedUserName'),
        'otp' :getHexAscii("", this.otp)
    };
    this.spinnerService.show();
    
        request.param1 =getHexAscii("",sessionStorage.getItem('custNo')+this.currentEmail+this.newEmail+otpDetails.userName+otpDetails.otp);
      request.param2 =sessionStorage.getItem('custNo');
        //request.param2 = this.currentEmail;
        request.param3 ='';
       request.param4 = this.currentEmail;
      request.param5 = this.newEmail;
        request.param6 = otpDetails;
      
      this.webService.getResponse(request, 'updateMobileNoOrEmailId').subscribe((data: IbResponse) => {
        response = data;
        //this.isLoad = false;
        this.spinnerService.hide();
        if (response !== null && response.status === 'S200') {
          this.isShow='page3';
        this.successResponse=response.param1;
        }
        else if(response !== null && response.status === 'OBJECT_NOT_FOUND')
        {
          console.log("come here for page 3");
          this.isShow='page3';
          this.successResponse=response.param1;
        }
        else if(response !== null && response.status === 'S333')
        {
          //this.isError1=true;
          this.otpError='backendError';
         this.error=response.param1;
        }else if(response !== null && response.status === 'S334')
        {
          //this.isError1=true;
          this.otpError='backendError';
         this.error=response.param1;
        } else if(response!=null){
          this.error=data.param1;
                }
           else {
          this.error = 'Something Went Wrong Please Contact Customer Care';
        }
      });
    }
  }
  back()
  {
    this.isShow='page1';
    this.otp='';
    this.isDisabled=false;
    this.newEmail='';
  }
  ok()
  {
    this.isShow='page1';
    this.currentEmail='';
    this.newEmail='';
    this.otp='';
  }
  oldEmailValidate()
  {
    var emailcont=this.currentEmail.includes("@");
    var emaildotcon=this.currentEmail.includes(".");
   if( this.currentEmail===undefined || this.currentEmail==='')
    {
    this.valideoldmailBlank="notemailBlank";
      this.isDisabled =true;
    }
     else if((emailcont===true && emaildotcon===false) || (emailcont===false && emaildotcon===true) || (emailcont===false && emaildotcon===false))
    {
     this.valideoldmail="notemail";
      this.isDisabled =true;
   }
    if( this.currentEmail.length>35)
    {
      this.emailLength='lengthGreater';
      this.isDisabled =true;
    }
  }
  removeMessagesOldEmail()
  {
    this.valideoldmail='';
    this.valideoldmailBlank ='';
    this.emailLength ='';
     this.isDisabled =false;
    
  }
  newEmailValidate()
  {
    var emailcontnew=this.newEmail.includes("@");
    var emaildotconnew=this.newEmail.includes(".");
   if( this.newEmail===undefined || this.newEmail==='')
    {
    this.validenewmail="notemailBlank";
      this.isDisabled =true;
    }
     else if((emailcontnew===true && emaildotconnew===false) || (emailcontnew===false && emaildotconnew===true) || (emailcontnew===false && emaildotconnew===false))
    {
     this.validenewmail="notemail";
      this.isDisabled =true;
   }
    if( this.currentEmail.length>35)
    {
      this.newemailLength='lengthGreater';
      this.isDisabled =true;
    }
  }
  removeMessagesnewEmail()
  {
    this.validenewmail='';
    this.validenewmail='';
    this.newemailLength='';
     this.isDisabled =false;
    
  }
  removeMessagesOTP()
  {
    this.invalidOtp='';
    this.otpBlank='';
    this.isDisabled =false;
    this.otpError='';
  }
  validateOtp(){  
    if(this.otp==='' || this.otp===' ' || this.otp===null || this.otp===undefined ){
      this.otpError='yes';
      return false;
    }else if(!this.otp.match(this.regNumsOnly)){
      this.otpError='nums';
      return false;
    }
    return true;
  }

  ngOnInit() {


    this.spinnerService.show();
     const request: IbRequest = new IbRequest();
      let response: IbResponse = null;
      let address:any=[];
      let custno =sessionStorage.getItem('custNo');
      request.param1=getHexAscii("",custno);
      request.param2=custno;
      this.webService.getResponse(request, 'customerAdressByCustNo').subscribe((data: IbResponse) => {
        response = data;
          this.spinnerService.hide();
         if (response.status === 'S101'){
          alert('Malicious Request Detected');
        }
        if(response.status==='S200'){

       //address= response.param6;
          address =response.param5;
          //this.addressDetailsarray= this.debitCardAddress.param6;
        
          this.currentEmail=address.EmailId.trim();
          console.log("cust info isss "+address);
          this.isShow='page1';
        }else if(response.status!='S200' && response.param1!=null){
          this.isShow='page3';
          this.successResponse=response.param1;
        }else{
          this.isShow='page3';
          this.successResponse='Something Went Wrong';
        }
      });
  }

}



// WEBPACK FOOTER //
// D:/Sonali/JCCBViewOnlyProject/ViewOnlyJCCBfrontend19112022/InternetBanking6.3frontend/src/app/update-email/update-email.component.ts